// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import UIkit from 'uikit';
import _ from 'lodash';
import Icons from '../node_modules/uikit/dist/js/uikit-icons';
import router from './router/router';

import './css/khi.less';

import kursbuch from './kursbuch.vue';
import store from './store/store';

Vue.prototype.$axios = axios;

// loads the Icon plugin
UIkit.use(Icons);
if (window.location.href.indexOf('localhost') === -1) {
  // eslint-disable-next-line no-undef
  window.jQuery = jQuery;
}
window.UIkit = UIkit;

Vue.config.productionTip = true;
Vue.config.devtools = true;
Vue.config.silent = false;

Vue.use(_);
Vue.use(Vuex);

window.Vue = new Vue({
  el: '#khi',
  store,
  router,
  template: '<kursbuch/>',
  components: {
    kursbuch,
  },
});

/*
router.beforeEach((to, from, next) => {
    console.log(to);
    console.log(from);
    console.log(next);
})
*/
